import $ from 'jquery';

(function () {
    'use strict';

    squiz.feedbackForm = function () {

        function submitFeedbackForm(event) {

            event.preventDefault();

            var $form = $(event.target);
            var $form_wrapper = $form.parent();
            var action_url = $form.prop("action") + '&SQ_ASSET_CONTENTS_RAW';
            var formData = new FormData($form[0]);
            var $formSuccess = $('.js-feedback-form-success');

            // Disable submit button
            var $submit_button = $form.find(".feedback-form__submit");
            $submit_button.prop("disabled", true);

            // Disable cancel button
            var $cancel_button = $form.find(".feedback-form__cancel");
            $cancel_button.prop("disabled", true);

            // As this not using the out of the box matrix input field
            // Have to manually add submit value so that Matrix can submit successfully
            var form_id = $form.prop("id");
            var submit_input_value = form_id + "_submit";
            formData.append(submit_input_value, "Submit");

            // Hide Default icon
            $form.find('.feedback-form-button__icon.default').addClass('hidden');

            // Show Spinner icon
            $form.find('.feedback-form-button__icon.loader').removeClass('hidden');

            // Get ready to post form data
            var xhr = new XMLHttpRequest();
            xhr.open("POST", action_url);

            xhr.onload = function () {

                // Remove form that was just submitted
                $form.remove();

                // $form_wrapper[0].scrollIntoView({ block: 'center' });

                // A 200 response doesn't mean the form was submitted successfully. 
                // There might be server validation issues
                // Check if the response contains a form tag or not
                // No form tag means its successful
                if (this.readyState == 4 && this.status == 200) {

                    var $response = $(this.response);

                    // If no form tag in response, its a success
                    if (!$response.is("form")) {

                        // Show success message that was hidden by CSS on page load
                        $('.feedback-form').slideToggle();
                        $('.feedback__button--more').after('<div class="feedback__thankyou"><svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00003 11.17L1.83003 7L0.410034 8.41L6.00003 14L18 2L16.59 0.589996L6.00003 11.17Z" fill="#4BDD5E"/></svg><span class="feedback-thankyou__text">Thank you for your feedback.</span></div>');
                        $('.feedback__button--more').remove();
                        $formSuccess.text('Thank you for your feedback.');

                        // Scroll instantly to top of feedback
                        var page_feedback_offset_top = $(".page-feedback").offset().top;
                        document.documentElement.scrollTop = page_feedback_offset_top;

                    } else {

                        // Append form with errors response
                        $form_wrapper.append($response);

                        // Scroll instantly to top of form wrapper
                        var form_wrapper_offset_top = $form_wrapper.offset().top;
                        document.documentElement.scrollTop = form_wrapper_offset_top;

                    }

                } else {

                    $form_wrapper.append('<p>Something went wrong. Please refresh the page and try again.</p>');
                    $formSuccess.text('Something went wrong. Please refresh the page and try again.');

                }

            };

            xhr.send(formData);

        }

        function init() {

            $feedback_form = $(".feedback-form form");

            if ($feedback_form.length) {

                $("body").on("submit", ".feedback-form form", submitFeedbackForm);

            }

        }

        var $feedback_form;

        return {
            init: init
        };

    }();

    document.addEventListener("DOMContentLoaded", function (event) {

        squiz.feedbackForm.init();

    });

}());
